import React from 'react';
import PostDetail from 'src/components/post/detail/PostDetail';

const Detail = () => {
  return <PostDetail />;
};

export default Detail;
